import Vue from "vue";

export default class DataLoader {
    config: Object;
    eventBus: Vue;
    isLoaded: Boolean;
    isLoading: Boolean;
    httpClient: Object;
    data: Object;
    dataLoadedEventName: string;
    setDataNotLoadedEventName: string;

    constructor(eventBus: Vue, httpClient: Object, config: Object) {
        this.config = config;
        this.eventBus = eventBus;
        this.httpClient = httpClient;
        this.isLoaded = false;
        this.isLoading = false;
        this.setDataNotLoadedEventName = `setDataNotLoaded:${this.config['index']}`;
        this.dataLoadedEventName = `dataLoaded:${this.config['index']}`;

        this.eventBus.$on(this.setDataNotLoadedEventName, () => {
            this.isLoaded = false;
        });
    }

    bindEvents(callback) {
        this.eventBus.$on(this.dataLoadedEventName, (data) => {
            callback(data);
        });
    }

    unbindEvents() {
        this.eventBus.$off(this.dataLoadedEventName);
        this.eventBus.$off(this.setDataNotLoadedEventName);
    }

    async load (params: Object) {
        if (!this.isLoading && this.isLoaded) {
            this.eventBus.$emit(this.dataLoadedEventName, this.data);
        }

        if (this.isLoaded) {
            return this.data;
        }
        this.isLoaded = true;
        this.isLoading = true;
        let response = await this.loadData(params);
        this.data = response.data.data;
        this.isLoading = false;
        this.eventBus.$emit(this.dataLoadedEventName, response.data.data);
        return this.data
    }

    async loadData(params: Object) {
        const url = this.config['loadUrl'];
        const method = this.config['method'] || 'get';

        return this.httpClient[method](url, {params: params});
    }
}


// WEBPACK FOOTER //
// ./src/services/DataLoader.ts